import Vue from 'vue'

import store from '@/store'
import router from '@/router'

import vueHeadful from 'vue-headful';
import App from '@/App.vue'

import { abilitiesPlugin } from '@casl/vue'
import vuetify from '@/plugins/vuetify';

import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';  


// global components
Vue.component('vue-headful', vueHeadful);

// global plugins
Vue.use(abilitiesPlugin, store.getters.ability)
Vue.use(VueFilterDateFormat);

Vue.config.productionTip = false

const vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})


vue.$mount('#app')
